package com.essntl.features.task.ui.addedittask

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.DateValidator
import core.validation.validator.NonEmptyValidator

class AddEditTaskValidation {
    val addEditTaskForm = AddEditTaskForm()
}

class AddEditTaskForm : Form() {

    var isEdit: Boolean = false

    val title =
        StringField(NonEmptyValidator)

    val dueDate =
        StringField(DateValidator)

    val owner =
        StringField(NonEmptyValidator)

    override val fields: List<Field>
        get() = buildList {
            add(title)
            add(dueDate)
            if (!isEdit)
                add(owner)
        }
}